import { z } from 'zod'

import { DEFAULT_PAGE, DEFAULT_PER_PAGE } from '@/core/lib/pagination'

export const tableSearchSchema = z.object({
  page: z.coerce.number().int().positive().catch(DEFAULT_PAGE),
  per_page: z.coerce.number().int().positive().max(200).catch(DEFAULT_PER_PAGE),
  q: z.string().optional().catch(undefined),
  sort: z.string().optional().catch(undefined),
  order: z.enum(['asc', 'desc']).optional().catch(undefined),
})

export type TTableSearch = z.infer<typeof tableSearchSchema>

export const makeTableSearchSchema = <Extra extends z.ZodRawShape>(
  extra: Extra
) => tableSearchSchema.extend(extra)

// Liste sayfaları için sade arama şeması (question-generation `batchSearchSchema`
// ile aynı sözleşme). TanStack Router search değerlerini JSON olarak çözdüğü için
// `page` sayı olarak gelir; `query` boşsa URL'den düşer.
export const listSearchSchema = z.object({
  page: z.number().optional(),
  query: z.string().optional(),
})

export type TListSearch = z.infer<typeof listSearchSchema>
